console.log('Updated:', 'Sun Oct 25 19:15:11 PDT 2026')
import './styles.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';

import Main from './components/Main';

const container = document.querySelector('#app');
if (container === null) {
  console.error('The container element could not be found');
} else {
  const root = createRoot(container);
  root.render(<Main />);
}
